import script from "./invoice-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./invoice-report-table.vue?vue&type=script&setup=true&lang=js"

import "./invoice-report-table.vue?vue&type=style&index=0&id=50a882d5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a882d5"]])

export default __exports__